import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import AmostrasComerciaisIndex from '@/pages/amostras-comerciais/AmostrasComerciaisIndex.vue';

const routes: RouteConfig[] = [
  {
    path: '/comercial',
    name: 'AmostrasComerciaisIndex',
    component: AmostrasComerciaisIndex,
    meta: {
      icon: 'mdi-handshake',
      rules: [CaslRules.Amostra.listarAcompanhamento],
    },
  },
];

export default routes;
